var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex" },
    [
      _c(
        "el-select",
        {
          staticStyle: { width: "100%" },
          attrs: {
            clearable: "",
            "remote-method": _vm.remoteMethod,
            placeholder: _vm.placeholder,
            filterable: "",
            "filter-method": _vm.handleAgreementSearch,
          },
          on: { change: _vm.changeSelect },
          model: {
            value: _vm.jumpId,
            callback: function ($$v) {
              _vm.jumpId = $$v
            },
            expression: "jumpId",
          },
        },
        _vm._l(_vm.jumpLists, function (item) {
          return _c("el-option", {
            key: item.id,
            attrs: { label: item.urlName, value: item.jumpvalue },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }